// extracted by mini-css-extract-plugin
module.exports = {"actionFootnote":"ProductActions_actionFootnote__WjInB","buttons":"ProductActions_buttons__5Erqc","button":"ProductActions_button__HIMFF"};